import React from "react";
import "./Home.css";

function Sink() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>SINK</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/camplux.webp" alt="Camplux Logo" />
              <br />
              Gooseneck Faucet w/ Camplux 6.5gal Hot Water Heater
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe
            src="https://drive.google.com/file/d/1ourTs3C3tod0IE8n1_YMjfSIdy3yNCmY/preview"
            title="Sink Video"
          ></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          Make sure the 5th switch on the switch panel (between toilet cabinet and bed) is flipped on. This turns on the water pump.
        </p>
        <p className="tealText">
          To turn on the hot water heater, plug it into the power strip under the sink.
        </p>
        <p className="tealText">
          The hot water heater sucks up a lot of battery power, so we recommend keeping it unplugged while driving long distances or if you’re not planning on using it anytime soon.
        </p>
        <p className="tealText">
          The red and blue PEX pipes under the sink supply water to the outdoor shower. If any leaking is happening towards the back of the van, turn off the valves on the PEX pipes to stop water flowing back towards the shower.
        </p>
        <p className="tealText">
          The water pump is under the sink on the right side. You can turn off the valve on the water pump to stop water being pumped out of the main water tank.
        </p>
        <p className="tealText">
          Avoid washing food scraps down the kitchen drain. Please use the strainer in the bottom of the sink!
        </p>
      </div>

      <div className="home-text-content">
          <div className="title-text-cont">
          <h1 style={{ paddingTop: "1em" }}>Grey Tank</h1>
          <p className="home-subtitle">
              <br />
              23-gal Undermount Water Tank
            </p>
          </div>
        </div>

      <div className="iframe-container">
        <iframe
          className="responsive-iframe"
          src="https://drive.google.com/file/d/1L8y51-xqngnN7PFhQMywuW1TxBnm5-rD/preview"
          title="Grey Tank Video"
        ></iframe>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          The sink drain comes down to the underside of the van on the driver's side. There is a 3-way valve to turn the drain open & closed to the grey tank and/or to the ground.
        </p>
        <p className="tealText">
          If the grey tank fills over its 23-gal capacity, it has an overflow valve that will drain excess to the ground.
        </p>
        <p className="tealText">
          The grey tank drain is an RV drain port on the passenger's side. Twist the cap counter-clockwise to remove, then slide the black handle to the right to let the water flow out.
        </p>
        <p className="tealText">
          <strong>Make sure you are familiar with any local rules when emptying grey water to the ground.</strong>
        </p>
      </div>

      <div className="movCont">
        <img src="/sink.jpg" className="home-image" alt="Sink system photo" />
      </div>
    </div>
  );
}

export default Sink;
